import React, { createContext, useContext, useState, useCallback } from 'react';

// Alert Context
const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);

    // Optimized function to show alert
    const showAlert = useCallback((status, message, autoHideDuration = 5000) => {
        const id = Date.now() + Math.random(); // More unique ID
        const newAlert = { id, status, message, autoHideDuration };

        setAlerts(prev => [...prev, newAlert]);

        // Auto remove alert after duration
        setTimeout(() => {
            removeAlert(id);
        }, autoHideDuration);
    }, []);

    // Optimized function to remove alert
    const removeAlert = useCallback((id) => {
        setAlerts(prev => prev.filter(alert => alert.id !== id));
    }, []);

    // Clear all alerts
    const clearAllAlerts = useCallback(() => {
        setAlerts([]);
    }, []);

    const value = {
        alerts,
        showAlert,
        removeAlert,
        clearAllAlerts
    };

    return (
        <AlertContext.Provider value={value}>
            {children}
        </AlertContext.Provider>
    );
};

// Custom hook to use alert context
export const useAlert = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlert must be used within an AlertProvider');
    }
    return context;
};